import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.repayment_schedule.title',
        defaultMessage: 'Repayment schedule'
    },
    cbilsTitle: {
        id: '_.modal.repayment_schedule.cbilsTitle',
        defaultMessage: 'CBILS repayment schedule'
    },
    date: {
        id: '_.modal.repayment_schedule.date',
        defaultMessage: 'Date'
    },
    principal: {
        id: '_.modal.repayment_schedule.principal',
        defaultMessage: 'Principal'
    },
    interest: {
        id: '_.modal.repayment_schedule.interest',
        defaultMessage: 'Interest'
    },
    totalRepayment: {
        id: '_.modal.repayment_schedule.totalRepayment',
        defaultMessage: 'Total Repayment'
    },
    total: {
        id: '_.modal.repayment_schedule.total',
        defaultMessage: 'Total:'
    },
    download: {
        id: '_.modal.repayment_schedule.download_button',
        defaultMessage: 'Download'
    }
});
